export default "__VITE_ASSET__BUBzeW_X__"